var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2H16C18.2091 2 20 3.79086 20 6V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V6C4 3.79086 5.79086 2 8 2ZM16 20C17.1046 20 18 19.1046 18 18V15.44C17.396 15.8036 16.705 15.997 16 16H8C7.29504 15.997 6.60399 15.8036 6 15.44V18C6 19.1046 6.89543 20 8 20H16ZM16 14C17.1046 14 18 13.1046 18 12V9.44C17.396 9.80355 16.705 9.99705 16 10H8C7.29504 9.99705 6.60399 9.80355 6 9.44V12C6 13.1046 6.89543 14 8 14H16ZM8 8H16C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4H8C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18C9 17.4477 8.55228 17 8 17Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavData);
export default ForwardRef;